import { IJourney } from "config";
import { exitPathOverrides } from "store/mock/journey.mock";
import { IJourneyWithActive, JourneyState } from "store/reducers/journey";

import { find, get, isEqual } from "lodash-es";

export const isOnboarding = (journey: JourneyState) => {
  return !!find(journey.collection, item => item?.parent === undefined && item.active === true);
};

type Translator = (key: string, fallback: string) => string;

/**
 * Builds the modal content for the JourneyExit modal based on the active journey.
 * Shared between JourneyLocalSync (blocker-triggered exit) and BackNav (direct button exit)
 * so both surfaces show consistent copy.
 */
export const buildJourneyExitContent = (journey?: IJourney, t?: Translator) => {
  const translate: Translator = t ?? ((_key, fallback) => fallback);

  const contentBasedOnJourney = {
    fulfillment: {
      condition: isEqual(journey?.slug, "fulfillment"),
      content: {
        header: translate("fulfillment.modal.title", "Do you really wanna exit mid-application?"),
        subheader: translate(
          "fulfillment.modal.body",
          "If you leave now, you might have to answer these questions again."
        ),
        buttons: {
          primary: translate("fulfillment.modal.primary", "YEAH, EXIT"),
          secondary: translate("fulfillment.modal.secondary", "NEVERMIND"),
        },
      },
    },
    testing: {
      condition: isEqual(journey?.slug, "default-journey"),
      content: {
        header: "Do you want to exit this testing journey?",
        subheader: "If you leave now, you will have to answer these questions again.",
      },
    },
  };

  const activeItem = find(contentBasedOnJourney, item => item.condition === true);
  return get(activeItem, "content", {});
};

export const getJourneyExitPath = (journey?: IJourneyWithActive) => {
  const slug = journey?.slug || "";

  const exitPathOverride: (() => string) | undefined = get(exitPathOverrides, slug);
  const exitPath = exitPathOverride ? exitPathOverride() : journey?.paths?.exit;

  return exitPath;
};
